import { LoggerModule } from './logger/logger.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatOptionModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule } from '@angular/material';
import { LocalStorageModule } from 'angular-2-local-storage';
import { StorageServiceModule} from 'angular-webstorage-service';
import { AuthModule } from './auth/auth.module';
import { PaymentModule } from './payment/payment.module';
import { PlanModule } from './plan/plan.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';
import { CustomerEnrollModule } from './customer-enroll/customer-enroll.module';
import { ProfileModule } from './profile/profile.module';
import { AppRoutingModule } from './app-routing.module';
import { ServiceAvailabilityModule } from './service-availability/service-availability.module';
import { PageNotFoundModule } from './page-not-found/page-not-found.module';
import { AgentModule } from './agent/agent.module';
import { TestModule } from './test/test.module';
import { CheckAvailabilityModule } from './check-availability/check-availability.module'
import { PlanDetailsModule } from './plan-details/plan-details.module'
import { CashOnlyDialog } from './dashboard/dashboard/dashboard.component';
import { UsageModule } from './usage/usage.module';
import {DataDogRumService} from './datadog/DataDogRumService';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';

@NgModule({
schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
  declarations: [
    AppComponent,
    ChatWidgetComponent
  ],
   exports: [MatButtonModule, MatCheckboxModule],
  imports: [
      NoopAnimationsModule,
      BrowserModule,
      BrowserAnimationsModule,
      MatAutocompleteModule,
      MatButtonModule,
      MatButtonToggleModule,
      MatCardModule,
      MatCheckboxModule,
      MatChipsModule,
      MatDatepickerModule,
      MatDialogModule,
      MatDividerModule,
      MatExpansionModule,
      MatFormFieldModule,
      MatGridListModule,
      MatIconModule,
      MatInputModule,
      MatListModule,
      MatMenuModule,
      MatNativeDateModule,
      MatOptionModule,
      MatPaginatorModule,
      MatProgressBarModule,
      MatProgressSpinnerModule,
      MatRadioModule,
      MatRippleModule,
      MatSelectModule,
      MatSidenavModule,
      MatSliderModule,
      MatSlideToggleModule,
      MatSnackBarModule,
      MatSortModule,
      MatStepperModule,
      MatTableModule,
      MatTabsModule,
      MatToolbarModule,
      MatTooltipModule,
      FormsModule,
      ReactiveFormsModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      AuthModule,
      PaymentModule,
      PlanModule,
      SharedModule,
      CustomerEnrollModule,
      DashboardModule,
      ProfileModule,
      ServiceAvailabilityModule,
      AgentModule,
      TestModule,
      CheckAvailabilityModule,
      PlanDetailsModule,
      PageNotFoundModule,
      StorageServiceModule,
      LoggerModule,
      UsageModule,
      LocalStorageModule.withConfig({
            prefix: 'my-app',
            storageType: 'localStorage'
        })
  ],
  providers: [DataDogRumService],
  entryComponents: [CashOnlyDialog],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts